/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { Text, useMantineTheme } from '@mantine/core';
import type React from 'react';
import { NavLink } from 'react-router-dom';

import { TextVariants } from '@fai/ui/components/typography/variants';
import { assertNonEmptyArray } from '@fai/util/types';

export function ProductNavLinks({
  products,
}: {
  products: { label: React.ReactElement | string; path: string }[];
}) {
  const theme = useMantineTheme();
  assertNonEmptyArray(products);

  return products.map((link, index) => (
    <NavLink
      key={link.path + index.toString()}
      style={({ isActive }) => ({
        textDecoration: 'none',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        color: isActive
          ? theme.pf.color.fg.cloudblue.default.base
          : theme.pf.color.fg.neutral.strong,
      })}
      to={link.path}
    >
      <Text variant={TextVariants.TitleXs}>{link.label}</Text>
    </NavLink>
  ));
}
